import { useEffect, useState } from 'react';
import { FormControl, InputLabel, ListSubheader, MenuItem, Select, FormHelperText, Grid } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import ErrorMessages from 'components/Global/ErrorMessages';
import mapValidators from 'utility/mapValidators';
import { useDispatch, useSelector } from 'react-redux';
import { SYSTEM_HANDLE_FORCE_CHECK_VALIDATION } from 'store/key';
import usePrevious from 'hooks/usePrevious';

const useStyles = makeStyles((theme) => ({
    listSubheader: {
        background: '#fff',
    },
    menuItem: {
        paddingLeft: '26px',
    },
    select: {
        fontSize: 14,
    },
    inputLabel: {
        fontSize: 14,
    },
}));

export default function CustomSelect(props) {
    const classes = useStyles();
    const {
        value = '',
        setValue,
        options,
        label,
        showPlaceholder = true,
        filterByGroup,
        idKey = 'key',
        sunIdKey = 'key',
        descKey = 'label',
        subDescKey = 'label',
        helperText,
        error,
        isValidValue = () => null,
        forceErrorDisplay = false,
        validators,
        isNoneSelect = false,
        ...other
    } = props;
    const labelText = showPlaceholder ? (label ? label : '') : null;

    const forceCheckValidation = useSelector((state) => state.system.forceCheckValidation);
    const dispatch = useDispatch();
    const [errorMessage, setErrorMessage] = useState([]);
    const [isOnBlurTriggered, setOnBlurTrigger] = useState(false);

    const preValidators = usePrevious(validators);

    // For 'forceCheckValidation' case
    useEffect(() => {
        if (forceCheckValidation) {
            onValidation(value);
            dispatch({
                type: SYSTEM_HANDLE_FORCE_CHECK_VALIDATION,
                payload: {
                    forceCheckValidation: false,
                },
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [forceCheckValidation]);

    useEffect(() => {
        onValidation(value);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // check errors first when input render
    useEffect(() => {
        onValidation(value);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [value]);

    useEffect(() => {
        if (validators?.toString() !== preValidators?.toString()) {
            onValidation(value);
        };
        // eslint-disable-next-line
    }, [validators]);

    // logic to force error display
    useEffect(() => {
        setOnBlurTrigger(forceErrorDisplay);
    }, [forceErrorDisplay]);

    const onValidation = (value) => {
        let tempError = mapValidators(value, validators);
        isValidValue(tempError.length === 0);
        setErrorMessage(tempError);
    };

    const handleOnBlur = (e) => {
        setOnBlurTrigger(true);
    };

    const onValueChange = (e) => {
        setValue(e);
    };

    const getGroupMenuItem = (props) => {
        return options.length
            ? options.map((i) => {
                  let html = [
                      <ListSubheader key={i[idKey]} className={classes.listSubheader}>
                          {i[descKey]}
                      </ListSubheader>,
                  ];
                  i.groups.map((n) =>
                      html.push(
                          <MenuItem key={n[sunIdKey]} value={n[sunIdKey]} className={classes.menuItem}>
                              {n[subDescKey]}
                          </MenuItem>,
                      ),
                  );
                  return html;
              })
            : null;
    };
    const getMenuItem = (props) => {
        return options.length
            ? options.map((i) => (
                  <MenuItem color="primary" key={i[idKey]} value={i[idKey]} className={classes.menuItem}>
                      {i[descKey]}
                  </MenuItem>
              ))
            : null;
    };
    return (
        <Grid container>
            <FormControl error={error} {...other} variant="outlined" size="small">
                {showPlaceholder ? <InputLabel className={classes.inputLabel}>{labelText}</InputLabel> : null}
                {showPlaceholder ? (
                    <Select
                        className={classes.select}
                        required
                        label={labelText}
                        value={value}
                        onChange={onValueChange}
                        onBlur={handleOnBlur}
                        error={errorMessage.length > 0 && isOnBlurTriggered}
                        {...other}
                    >
                        {isNoneSelect && <MenuItem value="" className={classes.menuItem}><em>None</em></MenuItem>}   
                        {filterByGroup ? getGroupMenuItem() : getMenuItem()}
                    </Select>
                ) : (
                    <Select
                        className={classes.select}
                        required
                        value={value}
                        onChange={onValueChange}
                        onBlur={handleOnBlur}
                        error={errorMessage.length > 0 && isOnBlurTriggered}
                        {...other}
                    >
                        {isNoneSelect && <MenuItem value="" className={classes.menuItem}><em>None</em></MenuItem>}   
                        {filterByGroup ? getGroupMenuItem() : getMenuItem()}
                    </Select>
                )}
                <FormHelperText>{helperText}</FormHelperText>
            </FormControl>
            <ErrorMessages isOnBlurTriggered={isOnBlurTriggered} errorMessage={errorMessage} />
        </Grid>
    );
}
